import { Grid } from 'antd';

/**
 * 移动端判定：< md(768px) 视为移动端浏览器。
 * 断点口径与 antd 栅格一致；各端保持同一份副本（与 StickyActionBar/table-const 惯例一致）。
 */
export function useIsMobile(): boolean {
  const screens = Grid.useBreakpoint();
  return screens.md === false;
}
